// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--b36dc";
export var wrapper = "index-module--wrapper--64929";